import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Expenses from "./Expenses";
import Payments from "./Payments";
import NewAccountL2 from "./NewAccountL2";
import { Drawer } from "@mui/material";

const CoaForms = () => {
  const [showExpenseForm, setShowExpenseForm] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const handleButtonClick = () => {
    setShowExpenseForm(!showExpenseForm);
  };
  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };
  const closeDrawer = () => {
    setIsFormVisible(false);
  };

  return (
    <>
      <div className="m-10 ">
        <div className="space-x-4">
          <button className="px-3 border text-white bg-103149 p-1 rounded" onClick={handleButtonClick}>
            Expense
          </button>

          <button onClick={toggleFormVisibility} className="mb-4 p-2 bg-blue-500 text-white rounded">
            {isFormVisible ? "Close Form" : "Open Form"}
          </button>
        </div>

        {isFormVisible && (
          <Drawer anchor="right" open={isFormVisible} onClose={closeDrawer}>
            <NewAccountL2 />
          </Drawer>
        )}

        <div className="mt-1">
          {showExpenseForm && (
            <div>
              {" "}
              {/* <Expenses />  */}
              <Payments />
            </div>
          )}
          {/* {showExpenseForm && <Payments/>} */}
        </div>
      </div>
    </>
  );
};
export default LayoutHOC(CoaForms);
